import React, { useState } from "react";
import styles from "./style.module.css";
import { buscarRelatorioAcessos } from "../../../api/requisicoes/relatorios"; // Assumindo que esta função existe
import Loading from "../../../components/Loading";
import Perfil from "../../../components/Perfil"; // Importando seu componente
import LocalDestino from "../../../components/LocalDestino"; // Importando seu componente
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaSearch, FaFileExcel } from "react-icons/fa"; // Importando ícones
import { useAlert } from "../../../context/AlertContext";

// Função auxiliar para formatar a data para o formato YYYY-MM-DD
const getTodayDateString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Meses são de 0 a 11
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

// Definição das colunas da tabela para controle de visibilidade
const colunasIniciais = {
    nomeCompleto: { label: "Nome", visivel: true },
    cpf: { label: "CPF", visivel: false },
    placa: { label: "Placa", visivel: false },
    perfil: { label: "Perfil", visivel: true },
    localDestino: { label: "Local de Destino", visivel: true },
    observacoes: { label: "Observações", visivel: false },
    dataEntrada: { label: "Data Entrada", visivel: true },
    horaEntrada: { label: "Hora Entrada", visivel: false },
    dataSaida: { label: "Data Saída", visivel: true },
    horaSaida: { label: "Hora Saída", visivel: false },
    nomeResponsavel: { label: "Responsável", visivel: false },
    quemAutorizou: { label: "Autorizador Saída", visivel: false },
    permanenciaDias: { label: "Permanência Dias", visivel: false },
    permanenciaHoras: { label: "Permanência Horas", visivel: false },
};

const colunasExcel = [
    { chave: "dataEntrada", titulo: "Data Entrada", largura: 13, data: true },
    {
        chave: "horaEntrada",
        titulo: "Hora Entrada",
        largura: 13,
        hora: true,
    },
    { chave: "dataSaida", titulo: "Data Saída", largura: 13, data: true },
    {
        chave: "horaSaida",
        titulo: "Hora Saída",
        largura: 13,
        hora: true,
    },
    { chave: "nomeCompleto", titulo: "Nome Completo", largura: 30 },
    { chave: "cpf", titulo: "CPF", largura: 15 },
    { chave: "perfil", titulo: "Perfil", largura: 22 },
    { chave: "placa", titulo: "Placa", largura: 12 },
    {
        chave: "localDestino",
        titulo: "Local de Destino",
        largura: 30,
    },
    { chave: "nomeResponsavel", titulo: "Responsável", largura: 25 },
    { chave: "observacoes", titulo: "Observações", largura: 35 },
    {
        chave: "saidaAutorizada",
        titulo: "Saída Autorizada",
        largura: 18,
    },
    { chave: "quemAutorizou", titulo: "Quem autorizou?", largura: 30 },
    {
        chave: "permanenciaDias",
        titulo: "Permanência Dias",
        largura: 17,
        inteiro: true,
    },
    {
        chave: "permanenciaHoras",
        titulo: "Permanência Horas",
        largura: 19,
        hora: true,
        duracao: true,
    },
];

const MILISSEGUNDOS_POR_DIA = 24 * 60 * 60 * 1000;
const DIAS_ENTRE_EPOCAS_UNIX_E_EXCEL = 25569;

const converterParaDataSemHorario = (valor) => {
    const texto = String(valor);
    const formatoBrasileiro = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    const formatoIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
    let dia;
    let mes;
    let ano;

    if (formatoBrasileiro) {
        [, dia, mes, ano] = formatoBrasileiro;
    } else if (formatoIso) {
        [, ano, mes, dia] = formatoIso;
    } else {
        return texto.slice(0, 10);
    }

    return (
        Date.UTC(Number(ano), Number(mes) - 1, Number(dia)) /
            MILISSEGUNDOS_POR_DIA +
        DIAS_ENTRE_EPOCAS_UNIX_E_EXCEL
    );
};

const converterParaHora = (valor) => {
    const texto = String(valor).trim();
    const partes = texto.match(/^(\d+):([0-5]\d)(?::([0-5]\d))?$/);

    if (!partes) return valor;

    const [, horas, minutos, segundos = "0"] = partes;
    const totalSegundos =
        Number(horas) * 3600 + Number(minutos) * 60 + Number(segundos);

    return totalSegundos / (24 * 60 * 60);
};

const converterParaInteiro = (valor) => {
    const numero = Number(valor);
    return Number.isFinite(numero) ? Math.trunc(numero) : valor;
};

const Relatorios = () => {
    const [dataInicio, setDataInicio] = useState(getTodayDateString());
    const [dataFim, setDataFim] = useState(getTodayDateString());
    const [idLocalDestino, setIdLocalDestino] = useState("");
    const [profileId, setProfileId] = useState("");
    const [loading, setLoading] = useState(false);
    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [colunasVisiveis, setColunasVisiveis] = useState(colunasIniciais);
    const { showAlert } = useAlert();

    const handleGerarRelatorio = async () => {
        setLoading(true);
        setDadosRelatorio([]); // Limpa os resultados anteriores
        if (!dataInicio || !dataFim) {
            showAlert("Data de início e fim são filtros obrigatórios.", "erro");
            setLoading(false);
            return;
        }
        try {
            const filtros = {
                dataInicio,
                dataFim,
                idLocalDestino,
                profileId,
            };
            const resultado = await buscarRelatorioAcessos(filtros);
            console.log("Resultado do relatório:", resultado);
            if (resultado.length === 0) {
                showAlert(
                    "Nenhum resultado encontrado.Por favor, altere os filtros e tente novamente.",
                    "erro"
                );
            }
            setDadosRelatorio(resultado);
        } catch (error) {
            showAlert(
                "Erro ao gerar o relatório. Verifique os filtros e tente novamente.",
                "erro"
            );
            console.error("Erro ao gerar relatório:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleVisibilidadeColuna = (chaveColuna) => {
        setColunasVisiveis((prevState) => ({
            ...prevState,
            [chaveColuna]: {
                ...prevState[chaveColuna],
                visivel: !prevState[chaveColuna].visivel,
            },
        }));
    };

    const handleExportarExcel = () => {
        if (dadosRelatorio.length === 0) {
            showAlert("Não há dados para exportar.", "erro");
            return;
        }

        const dadosParaExportar = dadosRelatorio.map((registro) =>
            Object.fromEntries(
                colunasExcel.map(({ chave, titulo, data, hora, inteiro }) => {
                    const valor = registro[chave];

                    if (data && valor) {
                        return [titulo, converterParaDataSemHorario(valor)];
                    }

                    if (hora && valor) {
                        return [titulo, converterParaHora(valor)];
                    }

                    if (
                        inteiro &&
                        valor !== "" &&
                        valor !== null &&
                        valor !== undefined
                    ) {
                        return [titulo, converterParaInteiro(valor)];
                    }

                    return [titulo, valor ?? ""];
                })
            )
        );

        const worksheet = XLSX.utils.json_to_sheet(dadosParaExportar);

        colunasExcel.forEach(
            ({ data, hora, inteiro, duracao }, indiceColuna) => {
                const formato = data
                    ? "dd/mm/yyyy"
                    : duracao
                    ? "[h]:mm:ss"
                    : hora
                    ? "hh:mm:ss"
                    : inteiro
                    ? "0"
                    : null;

                if (!formato) return;

                dadosParaExportar.forEach((_, indiceLinha) => {
                    const endereco = XLSX.utils.encode_cell({
                        r: indiceLinha + 1,
                        c: indiceColuna,
                    });
                    const celula = worksheet[endereco];

                    if (celula?.t === "n") {
                        celula.z = formato;
                    }
                });
            }
        );

        worksheet["!cols"] = colunasExcel.map(({ largura }) => ({
            wch: largura,
        }));
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        worksheet["!autofilter"] = { ref: XLSX.utils.encode_range(range) };

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Relatório de Acessos"
        );

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const data = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(data, "relatorio_de_acessos.xlsx");
    };

    return (
        <div className={styles.tela}>
            {loading && <Loading />}
            <div className={styles.containerRelatorios}>
                <div className={styles.headerRelatorio}>
                    <h1>Relatório de Acessos</h1>
                    {dadosRelatorio.length > 0 && (
                        <div className={styles.controlesDireita}>
                            <div className={styles.contadorResultados}>
                                <span>Total de Acessos</span>
                                <strong>{dadosRelatorio.length}</strong>
                            </div>
                            <button
                                className={styles.botaoExportar}
                                onClick={handleExportarExcel}
                                title="Exportar para Excel"
                            >
                                <FaFileExcel size={24} />
                            </button>
                        </div>
                    )}
                </div>
                <div className={styles.filtros}>
                    <div
                        className={`${styles.filtroItem} ${styles.filtroData}`}
                    >
                        <label htmlFor="dataInicio">Data Início</label>
                        <input
                            id="dataInicio"
                            type="date"
                            value={dataInicio}
                            onChange={(e) => setDataInicio(e.target.value)}
                            max={getTodayDateString()}
                        />
                    </div>
                    <div
                        className={`${styles.filtroItem} ${styles.filtroData}`}
                    >
                        <label htmlFor="dataFim">Data Fim</label>
                        <input
                            id="dataFim"
                            type="date"
                            value={dataFim}
                            onChange={(e) => setDataFim(e.target.value)}
                            min={dataInicio}
                            max={getTodayDateString()}
                        />
                    </div>
                    <div className={styles.filtroItem}>
                        <div className={styles.localDestinoWrapper}>
                            <LocalDestino
                                id="localDestino"
                                value={idLocalDestino.localDestination}
                                onChange={(selected) =>
                                    setIdLocalDestino(
                                        selected.localDestinationId
                                    )
                                }
                            />
                        </div>
                    </div>
                    <div className={styles.filtroItem}>
                        <div className={styles.localDestinoWrapper}>
                            <Perfil
                                label="Perfil"
                                id="perfil"
                                value={profileId.profileType}
                                onChange={(selected) =>
                                    setProfileId(selected.profileId)
                                }
                            />
                        </div>
                    </div>
                    <div className={styles.containerBotao}>
                        <button
                            onClick={handleGerarRelatorio}
                            className={styles.botaoGerar}
                            aria-label="Gerar Relatório"
                        >
                            <FaSearch size={20} />
                        </button>
                    </div>
                </div>

                <div className={styles.selecaoColunasContainer}>
                    <h3 className={styles.selecaoColunasTitulo}>
                        Selecione as colunas para exibir:
                    </h3>
                    <div className={styles.selecaoColunasGrid}>
                        {Object.entries(colunasVisiveis).map(
                            ([chave, { label, visivel }]) => (
                                <div
                                    key={chave}
                                    className={styles.colunaCheckboxItem}
                                >
                                    <input
                                        type="checkbox"
                                        id={`col-${chave}`}
                                        checked={visivel}
                                        onChange={() =>
                                            handleVisibilidadeColuna(chave)
                                        }
                                    />
                                    <label htmlFor={`col-${chave}`}>
                                        {label}
                                    </label>
                                </div>
                            )
                        )}
                    </div>
                </div>

                {dadosRelatorio.length > 0 && (
                    <div className={styles.containerTabela}>
                        <table className={styles.tabelaRelatorio}>
                            <thead>
                                <tr>
                                    {Object.entries(colunasVisiveis).map(
                                        ([chave, { label, visivel }]) =>
                                            visivel && (
                                                <th key={chave}>{label}</th>
                                            )
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {dadosRelatorio.map((item) => (
                                    <tr key={item.id}>
                                        {colunasVisiveis.nomeCompleto
                                            .visivel && (
                                            <td>{item.nomeCompleto}</td>
                                        )}
                                        {colunasVisiveis.cpf.visivel && (
                                            <td>{item.cpf}</td>
                                        )}
                                        {colunasVisiveis.placa.visivel && (
                                            <td>{item.placa}</td>
                                        )}
                                        {colunasVisiveis.perfil.visivel && (
                                            <td>{item.perfil}</td>
                                        )}
                                        {colunasVisiveis.localDestino
                                            .visivel && (
                                            <td>{item.localDestino}</td>
                                        )}
                                        {colunasVisiveis.observacoes
                                            .visivel && (
                                            <td>{item.observacoes}</td>
                                        )}
                                        {colunasVisiveis.dataEntrada
                                            .visivel && (
                                            <td>{item.dataEntrada}</td>
                                        )}
                                        {colunasVisiveis.horaEntrada
                                            .visivel && (
                                            <td>{item.horaEntrada}</td>
                                        )}
                                        {colunasVisiveis.dataSaida.visivel && (
                                            <td>{item.dataSaida}</td>
                                        )}
                                        {colunasVisiveis.horaSaida.visivel && (
                                            <td>{item.horaSaida}</td>
                                        )}
                                        {colunasVisiveis.nomeResponsavel
                                            .visivel && (
                                            <td>{item.nomeResponsavel}</td>
                                        )}
                                        {colunasVisiveis.quemAutorizou
                                            .visivel && (
                                            <td>{item.quemAutorizou}</td>
                                        )}
                                        {colunasVisiveis.permanenciaDias
                                            .visivel && (
                                            <td>{item.permanenciaDias}</td>
                                        )}
                                        {colunasVisiveis.permanenciaHoras
                                            .visivel && (
                                            <td>{item.permanenciaHoras}</td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Relatorios;
